const STEP = /^\s*\d+[.)]\s+/;
const BULLET = /^\s*[-*]\s+/;
const ESCALATE = /\[\[ESCALATE:(org|admicity)\|([^\]]+)]]/i;
const SHOW = /\[\[SHOW:([^\]]*)]]/gi;
const WALK = /\[\[WALK:(press|open)]]/gi;
const MOST_STEPS = 8;
const LONGEST_NAME = 80;

export const stripSentinel = (content) => String(content ?? '').replace(ESCALATE, '').replace(SHOW, '').replace(WALK, '').trim();

/**
 * AD-2653: a step of a walkthrough ends with [[WALK:press]] or [[WALK:open]]. "press" is done once the
 * last part named is pressed or filled in; "open" once the next screen opens after it. Anything else
 * is not a walkthrough step.
 */
export const readWalk = (content) => {
    const match = [...String(content ?? '').matchAll(WALK)].pop();
    return match ? match[1].toLowerCase() : null;
};

/**
 * The parts of the screen Felicity names, in the order a person presses them. She ends an answer
 * with [[SHOW:Settings|Manage Users|Parent Invitations|Resend invites]] when the panel asks for it.
 */
export const readShow = (content) => {
    const match = [...String(content ?? '').matchAll(SHOW)].pop();

    if (!match) {
        return [];
    }

    return match[1]
        .split('|')
        .map(name => name.trim())
        .filter(name => name.length > 0 && name.length <= LONGEST_NAME)
        .slice(0, MOST_STEPS);
};

export const toBlocks = (text) => {
    const lines = String(text ?? '').split('\n').filter(line => line.trim().length > 0);
    const blocks = [];

    for (const line of lines) {
        const kind = STEP.test(line) ? 'steps' : BULLET.test(line) ? 'bullets' : 'text';
        const body = line.replace(STEP, '').replace(BULLET, '').trim();
        const last = blocks[blocks.length - 1];

        if (last && last.kind === kind && kind !== 'text') {
            last.lines.push(body);
        } else {
            blocks.push({kind, lines: [body]});
        }
    }

    return blocks;
};

export const toBoldParts = (line) =>
    String(line ?? '').split(/\*\*(.+?)\*\*/g).map((part, index) => ({
        text: part,
        bold: index % 2 === 1
    }));

/**
 * AD-2660: the words shown for a reply. A reply holding only the outline marks says what is lit up,
 * and a reply holding nothing says she could not answer, so the panel never shows an empty bubble.
 */
export const replyWords = (reply, shown, noWords) => {
    const words = stripSentinel(reply).trim();
    if (words) {
        return words;
    }
    return readShow(reply).length ? shown : noWords;
};
